<div class="container">
    <h2>Provide the new Teltonika default login details</h2>
    <mat-form-field class="input">
        <mat-label>Username</mat-label>
        <input matInput [formControl]="usernameControl">
        @if(usernameControl.hasError('required')) {
        <mat-error>Username is required</mat-error>
        }
    </mat-form-field>

    <mat-form-field class="input">
        <mat-label>Password</mat-label>
        <input matInput type="password" [formControl]="passwordControl">
        @if (passwordControl.hasError('required')) {
        <mat-error>Password is required</mat-error>
        }
    </mat-form-field>
    <div class="button-container">
        <button mat-raised-button (click)="updateCredentials()"><i class="material-icons">upgrade</i>Update</button>
        <button mat-raised-button (click)="cancel()"><i class="material-icons">close</i>Cancel</button>
    </div>
</div>